<template>
  <button
    :class="inputClasses"
    :disabled="isDisabled"
    :type="type"
    class="button-input"
    @click="handleClick"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ButtonInput',
  props: {
    color: {
      type: String,
      default: () => 'normal',
      validator (value) {
        return ['normal', 'grey', 'error'].includes(value)
      }
    },
    outline: {
      type: Boolean,
      default: () => false
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: String,
      default: () => 'normal',
      validator (value) {
        return ['normal', 'big', 'full', 'square'].includes(value)
      }
    },
    type: {
      type: String,
      default: () => 'button'
    }
  },
  computed: {
    inputClasses () {
      return {
        'button-input--disabled': this.isDisabled,
        'button-input--outline': this.outline,
        'button-input--grey': this.color === 'grey',
        'button-input--error': this.color === 'error',
        'button-input--big': this.size === 'big',
        'button-input--full': this.size === 'full',
        'button-input--square': this.size === 'square'
      }
    }
  },
  methods: {
    handleClick (e) {
      if (!this.isDisabled) {
        this.$emit('click', e)
      }
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.button-input
  +font-size(14, 40)
  background: var(--buttonBackground)
  border-radius: 3px
  border: 2px solid transparent
  color: $color-white
  cursor: pointer
  display: inline-block
  font-family: $font-1
  font-weight: 600
  height: rem-calc(42)
  overflow: hidden
  padding: rem-calc(0 18)
  position: relative
  text-align: center
  text-overflow: ellipsis
  transition: $global-transition
  white-space: nowrap

  &:hover,
  &:focus
    background: var(--buttonBackgroundHover)
    outline: 0 none
    text-decoration: none

  &:active
    box-shadow: inset $shadow-4dp

  .svg-inline--fa + span
    margin-left: rem-calc(3)

  .fa.fa-angle-down
    &:first-child
      margin-right: 0

.button-input--full
  display: block

.button-input--error
  background: $color-error

  &:hover,
  &:focus
    background: $color-error-dark

.button-input--grey,
.button-input--disabled
  background: #e1e6eb
  color: $color-white

  &:hover,
  &:focus
    background: $color-grey-2

.button-input--grey
  color: #000

  &:hover,
  &:focus
    background: darken(#e1e6eb, 5%)

.button-input--full
  width: 100%

.button-input--big
  +font-size(24, 72)

  height: rem-calc(80)
  padding: rem-calc(0 40)

.button-input--square
  padding: 0
  text-align: center
  width: rem-calc(50)

  .fa
    margin-right: 0 !important

.button-input--outline
  background: transparent
  border: 1px solid var(--mainColor)
  color: var(--mainColor)

  &:hover,
  &:focus
    background: transparent
    border: 1px solid var(--mainColorHover)
    color: var(--mainColorHover)

.button-input--outline.button-input--disabled
  border-color: #e1e6eb
  color: #e1e6eb
</style>



// WEBPACK FOOTER //
// src/components/ui/ButtonInput.vue